import { ConfirmationStatusElement, DeliveryStatusElement } from "../constants/others"

export const changeColor = (status) => {
    const commonStyles = {
        padding: "2px 4px",
        textAlign: "center",
        borderRadius: "4px",
        fontSize:"16px",
        fontWeight: "bolder"
    };

    switch (status) {
        case DeliveryStatusElement.Shipped:
            return {
                ...commonStyles,
                color: "#1E90FF",
                border: "3px solid #1E90FF"
            };
        case DeliveryStatusElement.Delivered:
            return {
                ...commonStyles,
                color: "#008000",
                border: "3px solid #008000"
            };
        case DeliveryStatusElement.Canceled:
            return {
                ...commonStyles,
                color: "#FF0000",
                border: "3px solid #FF0000"
            };
        case DeliveryStatusElement.Postponed:
            return {
                ...commonStyles,
                color: "#6A5ACD",
                border: "3px solid #6A5ACD"
            };
        case DeliveryStatusElement.InProgress:
            return {
                ...commonStyles,
                color: "#57FEFF",
                border: "3px solid #57FEFF"
            };
        case DeliveryStatusElement.Unreachable:
            return {
                ...commonStyles,
                color: "#FFA07A",
                border: "3px solid #FFA07A"
            };
        case DeliveryStatusElement.Refused:
            return {
                ...commonStyles,
                color: "#DC143C",
                border: "3px solid #DC143C"
            };
        case DeliveryStatusElement.Added:
        case DeliveryStatusElement.PickedUp:
            return {
                ...commonStyles,
                color: "#848482",
                border: "3px solid #848482"
            };
        case DeliveryStatusElement.Changed:
            return {
                ...commonStyles,
                color: "#DAA520",
                border: "3px solid #DAA520"
            };
        case DeliveryStatusElement.RecipientChanged:
            return {
                ...commonStyles,
                color: "#FF69B4",
                border: "3px solid #FF69B4"
            };
        case DeliveryStatusElement.DuplicateOrder:
            return {
                ...commonStyles,
                color: "#8A2BE2",
                border: "3px solid #8A2BE2"
            };
        case DeliveryStatusElement.NeedFollowUp:
            return {
                ...commonStyles,
                color: "#FF6347",
                border: "3px solid #FF6347"
            };
        case DeliveryStatusElement.ReturnRequested:
            return {
                ...commonStyles,
                color: "#FFA500",
                border: "3px solid #FFA500"
            };
        case DeliveryStatusElement.WaitingForReturn:
            return {
                ...commonStyles,
                color: "#FFD700",
                border: "3px solid #FFD700"
            };
        case DeliveryStatusElement.OutOfZone:
            return {
                ...commonStyles,
                color: "#A52A2A",
                border: "3px solid #A52A2A"
            };
        case DeliveryStatusElement.Interested:
            return {
                ...commonStyles,
                color: "#32CD32",
                border: "3px solid #32CD32"
            };
        case DeliveryStatusElement.NoResponse:
            return {
                ...commonStyles,
                color: "#FFA600",
                border: "3px solid #FFA600"
            };
        case DeliveryStatusElement.ReadyForShipment:
            return {
                ...commonStyles,
                color: "#4682B4",
                border: "3px solid #4682B4"
            };
        case DeliveryStatusElement.Scheduled:
            return {
                ...commonStyles,
                color: "#9370DB",
                border: "3px solid #9370DB"
            };
        case DeliveryStatusElement.Received:
            return {
                ...commonStyles,
                color: "#3CB371",
                border: "3px solid #3CB371"
            };
        case DeliveryStatusElement.ClientReturnShipped:
            return {
                ...commonStyles,
                color: "#FF4500",
                border: "3px solid #FF4500"
            };
        case DeliveryStatusElement.ClientReturnReceived:
            return {
                ...commonStyles,
                color: "#40E0D0",
                border: "3px solid #40E0D0"
            };
        case DeliveryStatusElement.Returned:
            return {
                ...commonStyles,
                color: "#FF8C00",
                border: "3px solid #FF8C00"
            };
        case DeliveryStatusElement.CourierReturnShipped:
            return {
                ...commonStyles,
                color: "#2E8B57",
                border: "3px solid #2E8B57"
            };
        case ConfirmationStatusElement.DoubleOrderConfirmed:
            return { ...commonStyles, color: "#008000", border: "3px solid #008000" }; // Green
        case ConfirmationStatusElement.Unreachable:
            return { ...commonStyles, color: "#FFA07A", border: "3px solid #FFA07A" }; // Light Salmon
        case ConfirmationStatusElement.WrongNumber:
            return { ...commonStyles, color: "#FF0000", border: "3px solid #FF0000" }; // Red
        case ConfirmationStatusElement.DoubleOrder:
            return { ...commonStyles, color: "#8A2BE2", border: "3px solid #8A2BE2" }; // Blue Violet
        case ConfirmationStatusElement.FirstCall:
            return { ...commonStyles, color: "#1E90FF", border: "3px solid #1E90FF" }; // Dodger Blue
        case ConfirmationStatusElement.MessageWhatsApp:
            return { ...commonStyles, color: "#25D366", border: "3px solid #25D366" }; // WhatsApp green
        case ConfirmationStatusElement.Confirmed:
            return { ...commonStyles, color: "#32CD32", border: "3px solid #32CD32" }; // Lime Green
        case ConfirmationStatusElement.Recalled:
            return { ...commonStyles, color: "#FFA500", border: "3px solid #FFA500" }; // Orange
        case ConfirmationStatusElement.SecondCall:
            return { ...commonStyles, color: "#4682B4", border: "3px solid #4682B4" }; // Steel Blue
        case ConfirmationStatusElement.ThirdCall:
            return { ...commonStyles, color: "#9370DB", border: "3px solid #9370DB" }; // Medium Purple
        case ConfirmationStatusElement.NoAnswer:
            return { ...commonStyles, color: "#FFD700", border: "3px solid #FFD700" }; // Gold
        case ConfirmationStatusElement.Cancelled:
            return { ...commonStyles, color: "#DC143C", border: "3px solid #DC143C" }; // Crimson
        case ConfirmationStatusElement.OutsideConfirmedZone:
            return { ...commonStyles, color: "#A52A2A", border: "3px solid #A52A2A" }; // Brown
        case ConfirmationStatusElement.Pending:
            return { ...commonStyles, color: "#848482", border: "3px solid #848482" }; // Gray
        default:
            return {
                ...commonStyles,
                color: "#000",
                border: "3px solid #000"
            };
    }
};

export const changeBgColor = (status) => {
    switch (status) {
        case DeliveryStatusElement.Shipped:
            return "#1E90FF"; // Dodger Blue
        case DeliveryStatusElement.Delivered:
            return "#008000"; // Green
        case DeliveryStatusElement.Canceled:
            return "#FF0000"; // Red
        case DeliveryStatusElement.Postponed:
            return "#6A5ACD"; // Slate Blue
        case DeliveryStatusElement.InProgress:
            return "#57FEFF"; // Aqua
        case DeliveryStatusElement.Unreachable:
            return "#FFA07A"; // Light Salmon
        case DeliveryStatusElement.Refused:
            return "#DC143C"; // Crimson
        case DeliveryStatusElement.Added:
        case DeliveryStatusElement.PickedUp:
            return "#848482"; // Gray
        case DeliveryStatusElement.Changed:
            return "#DAA520"; // Goldenrod
        case DeliveryStatusElement.RecipientChanged:
            return "#FF69B4"; // Hot Pink
        case DeliveryStatusElement.DuplicateOrder:
            return "#8A2BE2"; // Blue Violet
        case DeliveryStatusElement.NeedFollowUp:
            return "#FF6347"; // Tomato
        case DeliveryStatusElement.ReturnRequested:
            return "#FFA500"; // Orange
        case DeliveryStatusElement.WaitingForReturn:
            return "#FFD700"; // Gold
        case DeliveryStatusElement.OutOfZone:
            return "#A52A2A"; // Brown
        case DeliveryStatusElement.Interested:
            return "#32CD32"; // Lime Green
        case DeliveryStatusElement.NoResponse:
            return "#FFA600"; // Dark Orange
        case DeliveryStatusElement.ReadyForShipment:
            return "#4682B4"; // Steel Blue
        case DeliveryStatusElement.Scheduled:
            return "#9370DB"; // Medium Purple
        case DeliveryStatusElement.Received:
            return "#3CB371"; // Medium Sea Green
        case DeliveryStatusElement.ClientReturnShipped:
            return "#FF4500"; // Orange Red
        case DeliveryStatusElement.ClientReturnReceived:
            return "#40E0D0"; // Turquoise
        case DeliveryStatusElement.Returned:
            return "#FF8C00"; // Dark Orange
        case DeliveryStatusElement.CourierReturnShipped:
            return "#2E8B57"; // Sea Green
        case ConfirmationStatusElement.DoubleOrderConfirmed: return "#008000";
        case ConfirmationStatusElement.Unreachable: return "#FFA07A";
        case ConfirmationStatusElement.WrongNumber: return "#FF0000";
        case ConfirmationStatusElement.DoubleOrder: return "#8A2BE2";
        case ConfirmationStatusElement.FirstCall: return "#1E90FF";
        case ConfirmationStatusElement.MessageWhatsApp: return "#25D366";
        case ConfirmationStatusElement.Confirmed: return "#32CD32";
        case ConfirmationStatusElement.Recalled: return "#FFA500";
        case ConfirmationStatusElement.SecondCall: return "#4682B4";
        case ConfirmationStatusElement.ThirdCall: return "#9370DB";
        case ConfirmationStatusElement.NoAnswer: return "#FFD700";
        case ConfirmationStatusElement.Cancelled: return "#DC143C";
        case ConfirmationStatusElement.OutsideConfirmedZone: return "#A52A2A";
        case ConfirmationStatusElement.Pending: return "#848482";
        default:
            return "#000";
    }
};

export const changeConfirmationColor = (status) => {
    const commonStyles = {
        padding: "2px 4px",
        textAlign: "center",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "bolder"
    };

    switch (status) {
        case ConfirmationStatusElement.DoubleOrderConfirmed:
            return { ...commonStyles, color: "#008000", border: "3px solid #008000" }; // Green
        case ConfirmationStatusElement.Unreachable:
            return { ...commonStyles, color: "#FFA07A", border: "3px solid #FFA07A" }; // Light Salmon
        case ConfirmationStatusElement.WrongNumber:
            return { ...commonStyles, color: "#FF0000", border: "3px solid #FF0000" }; // Red
        case ConfirmationStatusElement.DoubleOrder:
            return { ...commonStyles, color: "#8A2BE2", border: "3px solid #8A2BE2" }; // Blue Violet
        case ConfirmationStatusElement.FirstCall:
            return { ...commonStyles, color: "#1E90FF", border: "3px solid #1E90FF" }; // Dodger Blue
        case ConfirmationStatusElement.MessageWhatsApp:
            return { ...commonStyles, color: "#25D366", border: "3px solid #25D366" }; // WhatsApp green
        case ConfirmationStatusElement.Confirmed:
            return { ...commonStyles, color: "#32CD32", border: "3px solid #32CD32" }; // Lime Green
        case ConfirmationStatusElement.Recalled:
            return { ...commonStyles, color: "#FFA500", border: "3px solid #FFA500" }; // Orange
        case ConfirmationStatusElement.SecondCall:
            return { ...commonStyles, color: "#4682B4", border: "3px solid #4682B4" }; // Steel Blue
        case ConfirmationStatusElement.ThirdCall:
            return { ...commonStyles, color: "#9370DB", border: "3px solid #9370DB" }; // Medium Purple
        case ConfirmationStatusElement.NoAnswer:
            return { ...commonStyles, color: "#FFD700", border: "3px solid #FFD700" }; // Gold
        case ConfirmationStatusElement.Cancelled:
            return { ...commonStyles, color: "#DC143C", border: "3px solid #DC143C" }; // Crimson
        case ConfirmationStatusElement.OutsideConfirmedZone:
            return { ...commonStyles, color: "#A52A2A", border: "3px solid #A52A2A" }; // Brown
        case ConfirmationStatusElement.Pending:
            return { ...commonStyles, color: "#848482", border: "3px solid #848482" }; // Gray
        default:
            return { ...commonStyles, color: "#000", border: "3px solid #000" };
    }
};

export const changeConfirmationBgColor = (status) => {
    switch (status) {
        case ConfirmationStatusElement.DoubleOrderConfirmed: return "#008000";
        case ConfirmationStatusElement.Unreachable: return "#FFA07A";
        case ConfirmationStatusElement.WrongNumber: return "#FF0000";
        case ConfirmationStatusElement.DoubleOrder: return "#8A2BE2";
        case ConfirmationStatusElement.FirstCall: return "#1E90FF";
        case ConfirmationStatusElement.MessageWhatsApp: return "#25D366";
        case ConfirmationStatusElement.Confirmed: return "#32CD32";
        case ConfirmationStatusElement.Recalled: return "#FFA500";
        case ConfirmationStatusElement.SecondCall: return "#4682B4";
        case ConfirmationStatusElement.ThirdCall: return "#9370DB";
        case ConfirmationStatusElement.NoAnswer: return "#FFD700";
        case ConfirmationStatusElement.Cancelled: return "#DC143C";
        case ConfirmationStatusElement.OutsideConfirmedZone: return "#A52A2A";
        case ConfirmationStatusElement.Pending: return "#848482";
        default: return "#000";
    }
};
